import { render, staticRenderFns } from "./InputItem.vue?vue&type=template&id=aa6625f0&scoped=true&"
import script from "./InputItem.vue?vue&type=script&lang=js&"
export * from "./InputItem.vue?vue&type=script&lang=js&"
import style0 from "./InputItem.vue?vue&type=style&index=0&id=aa6625f0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6625f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('aa6625f0', component.options)
    } else {
      api.reload('aa6625f0', component.options)
    }
    module.hot.accept("./InputItem.vue?vue&type=template&id=aa6625f0&scoped=true&", function () {
      api.rerender('aa6625f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Field/InputItem.vue"
export default component.exports